import React, { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { Col, Container, Row } from "react-bootstrap";
import { config } from '../../config';
import { Logo } from '../../assets/images';
import { HomeOutlined, CancelOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import "./style.scss";

const AuthLayout = () => {
    const { projectDetails: { name }, routes: { home } } = config;
    const { user } = useSelector(state => state.auth);
    const navigate = useNavigate();

    useEffect(() => {
        if (Object.keys(user).length) {
            navigate(home);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Container fluid className='auth-layout'>
            <Row>
                <Col lg={6} className='banner'>
                    <img src={Logo} alt={name} title={name} />
                    <div className='toolbar'>
                        <CancelOutlined
                            onClick={() => navigate(-1)}
                        />
                        <HomeOutlined
                            onClick={() => navigate(home)}
                        />
                    </div>
                </Col>
                <Col lg={6} className='forms'>
                    <Outlet />
                </Col>
            </Row>
        </Container>
    )
}

export default AuthLayout;